import DashboardLink from '@/components/dashboard/dashboard-link/dashboard-link';
import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import MainContent from '@/components/main-layout/components/main-content/main-content';
import { ROUTE_ACCOUNT } from '@/constants/routes';
import { Box } from '@cmpsr/components';
import { UseFormReturn } from 'react-hook-form';
import AccountPanel from '../common/account-panel';
import EditEmailAddress from './components/edit-email-address.page';
import EditPersonalInfoForm from './components/edit-personal-info-form';
import useEditPersonalInfoController from './edit-personal-info.controller';

type EditPersonalInfoFormState = {
  name: string;
  email: string;
};

export type EditPersonalInfoPageProps = {
  form: UseFormReturn<EditPersonalInfoFormState>;
};

export default function EditPersonalInfoPage() {
  const { form, handleSubmit, onCloseEditEmailModal, onShowEditEmailModal, showEditEmailModal } =
    useEditPersonalInfoController();

  return (
    <>
      <DashboardNavigationBar />
      <MainContent>
        <DashboardLink href={ROUTE_ACCOUNT}>Account</DashboardLink>
        <Box
          py={{ base: 'spacer-4', md: 'spacer-8', lg: 'spacer-12' }}
          px={{ base: 'spacer-5', md: 'spacer-8', lg: 'spacer-44', xl: 'spacer-60', xxl: 'spacer-80' }}
          maxWidth="1440px"
          marginX="auto"
        >
          <AccountPanel header="Personal Info">
            <EditPersonalInfoForm
              form={form}
              handleSubmit={handleSubmit}
              onEditEmailAddressClick={onShowEditEmailModal}
            />
            {showEditEmailModal && <EditEmailAddress onDone={onCloseEditEmailModal} />}
          </AccountPanel>
        </Box>
      </MainContent>
    </>
  );
}
